import ReceiptDetailInterface from './ReceiptDetailInterface';

export default class ReceiptDetail implements ReceiptDetailInterface {
    id: string
    resource: string
    title: string
    resourceFile: string
    mimeType: string

    constructor(id: string, resource: string, title: string, resourceFile: string, mimeType: string) {
        this.id = id
        this.resource = resource
        this.title = title
        this.resourceFile = resourceFile
        this.mimeType = mimeType
    }
}
